export default {
  "content": "<path d=\"M8 1.5l2.469 3.602 4.188 1.235-2.663 3.46.12 4.366L8 12.7l-4.114 1.463.12-4.365-2.663-3.461L5.53 5.102 8 1.5z\" stroke=\"#ff00cb\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};